export default __webpack_public_path__ + "static/media/News_thumbnail.9d07a436.PNG";